import { useCallback } from 'react'
import {
	FileContainer,
	fileSelectors,
	fileSlice,
	FileStatuses,
	FileWithPreview,
	prepareFileDescr,
	UploadProps,
} from 'Modules'
import { formatDateForNewUpload, getActualSize } from 'Helpers'
import { getBaseUrl } from '@pp/axios'
import { useAppDispatch, useEffectOnce } from 'Src/hooks'
import { useSelector } from 'react-redux'

type InitialValueProps = Pick<
	UploadProps,
	'fieldOptions' | 'initialValue' | 'form' | 'noAutoUpload' | 'fieldName'
>

const actions = {
	getFile: fileSlice.actions.getFileBlob,
	setFileContainersList: fileSlice.actions.setFileContainersList,
}

export const useInitialValue = ({
	fieldOptions,
	initialValue,
	form,
	noAutoUpload,
	fieldName,
}: InitialValueProps) => {
	const { getFile, setFileContainersList } = useAppDispatch(actions)
	const filesBlob = useSelector(fileSelectors.getFilesBlob)

	const getPrepareFile = useCallback(
		(rawFile: FileWithPreview) => {
			let copyRawFile = rawFile
			const url = copyRawFile.file
			if (!noAutoUpload) {
				const blobFile = url?.startsWith('public')
					? `${getBaseUrl(true)}/${url}`
					: filesBlob.get(url)
				if (blobFile) {
					copyRawFile = {
						...copyRawFile,
						preview: (url?.startsWith('public')
							? blobFile
							: window.URL.createObjectURL(blobFile)) as string,
					}
				} else {
					getFile({
						url,
					})
				}
			}
			return copyRawFile
		},
		[filesBlob]
	)

	useEffectOnce(() => {
		const initialFiles = (fieldOptions?.initialValue as FileWithPreview[]) || initialValue
		const list: FileContainer[] = []
		if (initialFiles) {
			initialFiles.forEach((file) => {
				list.push({
					file: getPrepareFile(file),
					status: FileStatuses.COMPLETE,
					description: prepareFileDescr([
						getActualSize(file.size),
						formatDateForNewUpload(file.created_at ?? new Date().toString()),
					]),
				})
			})
			setFileContainersList({
				fieldName,
				fileContainersList: list,
			})
			form?.setFieldsValue({ [fieldName]: initialFiles })
		}
	})
}
